import { OrderStatus, getOrderStatusSubset } from "@constant/OrderStatus";

export const { OrderStatusOptions, OrderStatusLabel } = getOrderStatusSubset([
  OrderStatus.CANCEL,
  OrderStatus.WAITING_DEPLOY,
  OrderStatus.PROCESSING,
  OrderStatus.PICKING,
  OrderStatus.OUT_OF_STOCK,
  OrderStatus.ALREADY_SHIPPED,
  OrderStatus.SHIPPING_ABNORMAL,
  OrderStatus.FINISH,
]);
